/* istanbul ignore file */
import { Component, Input } from '@angular/core';
import { ICaseDetail } from 'src/app/model/support/ICaseDetail';

@Component({
  selector: 'app-tech-support-preview',
  templateUrl: './tech-support-preview.component.html',
  styleUrls: ['./tech-support-preview.component.scss']
})
export class TechSupportPreviewComponent {

  @Input() caseDetails: ICaseDetail[] = null;

}
